// extracted by mini-css-extract-plugin
export default {"module":"module__V2WGq","adviceColumnContainer":"adviceColumnContainer__FmvBY"};